import { __extends, __rest, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { AutoSizer, MultiGrid as MultiGrid$1 } from 'react-virtualized';
import { IconChevronRight, IconChevronLeft } from '@tabler/icons';
import { propTypes, defaultProps } from './MultiGrid.types.js';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import colors from '../../util/colors.js';
import styles from './MultiGrid.module.scss.js';

var MultiGrid = /** @class */ (function (_super) {
    __extends(MultiGrid, _super);
    function MultiGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            scrollPosition: 'left',
        };
        _this.toggleScrollPosition = function () {
            _this.setState(function (prevState) { return ({
                scrollPosition: prevState.scrollPosition === 'left' ? 'right' : 'left',
            }); });
        };
        _this.getRowClassName = function (row) {
            if (row === 0) {
                return styles.MultiGrid_headerRow;
            }
            else {
                return styles.MultiGrid_row;
            }
        };
        _this.getTotalColumnsWidth = function () {
            var _a = _this.props, columnWidth = _a.columnWidth, columnCount = _a.columnCount;
            if (typeof columnWidth === 'number') {
                return columnWidth * columnCount;
            }
            var currentIndex = 0;
            var totalWidth = 0;
            for (; currentIndex < columnCount; currentIndex++) {
                totalWidth += columnWidth({ index: currentIndex });
            }
            return totalWidth;
        };
        _this.renderCellContainer = function (data) {
            var _a = _this.props, cellContentRenderer = _a.cellContentRenderer, fixedColumnCount = _a.fixedColumnCount, cellClassName = _a.cellClassName, columnCount = _a.columnCount, cellContainerClassName = _a.cellContainerClassName;
            var columnIndex = data.columnIndex, key = data.key, rowIndex = data.rowIndex, style = data.style, isScrolling = data.isScrolling, isVisible = data.isVisible, parent = data.parent;
            var isHeaderCell = rowIndex === 0;
            var isRightSideCell = !fixedColumnCount || columnIndex + 1 > fixedColumnCount;
            var isBoundaryCell = columnIndex + 1 === fixedColumnCount;
            var isLastColumnCell = columnIndex + 1 === columnCount;
            var rowClassName = _this.getRowClassName(rowIndex);
            var separatorClassName = isHeaderCell &&
                !isLastColumnCell &&
                (isRightSideCell || isBoundaryCell)
                ? styles.MultiGrid_cell___wSeparator
                : '';
            var borderRightClassName = !isHeaderCell && (isRightSideCell || isBoundaryCell)
                ? styles.MultiGrid_cell___wBorderRight
                : '';
            var customCellContainer = typeof cellContainerClassName === 'function'
                ? cellContainerClassName({ rowIndex: rowIndex, columnIndex: columnIndex })
                : cellContainerClassName;
            var classNames = clsx(styles.MultiGrid_cell, rowClassName, separatorClassName, borderRightClassName, customCellContainer);
            return (React__default.createElement("div", { className: classNames, key: key, style: style },
                React__default.createElement("div", { className: clsx(styles.MultiGrid_cellContent, cellClassName) }, cellContentRenderer({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex,
                    isScrolling: isScrolling,
                    isVisible: isVisible,
                    parent: parent,
                }))));
        };
        return _this;
    }
    MultiGrid.prototype.render = function () {
        var _this = this;
        var _a = this.props, height = _a.height, width = _a.width, classNameBottomRightGrid = _a.classNameBottomRightGrid, classNameBottomLeftGrid = _a.classNameBottomLeftGrid, classNameTopRightGrid = _a.classNameTopRightGrid, classNameTopLeftGrid = _a.classNameTopLeftGrid, rowHeight = _a.rowHeight, showScrollButton = _a.showScrollButton, multiGridProps = __rest(_a, ["height", "width", "classNameBottomRightGrid", "classNameBottomLeftGrid", "classNameTopRightGrid", "classNameTopLeftGrid", "rowHeight", "showScrollButton"]);
        var safeRowHeight = rowHeight ||
            (function (_a) {
                var index = _a.index;
                return (index === 0 ? 54 : 68);
            });
        var headerHeight = typeof safeRowHeight === 'function'
            ? safeRowHeight({ index: 0 })
            : safeRowHeight;
        return (React__default.createElement(AutoSizer, { disableHeight: !!height, disableWidth: !!width }, function (autoSizerParams) { return (React__default.createElement(React__default.Fragment, null,
            showScrollButton &&
                _this.getTotalColumnsWidth() >
                    autoSizerParams.width && (React__default.createElement("div", { className: styles.RightElement, style: {
                    height: headerHeight,
                    width: width
                        ? width
                        : autoSizerParams.width,
                } },
                React__default.createElement(ButtonBase, { type: "button", className: styles.RightElement_iconButton, onClick: _this.toggleScrollPosition }, _this.state.scrollPosition ===
                    'left' ? (React__default.createElement(IconChevronRight, { color: colors.primary50, size: 22 })) : (React__default.createElement(IconChevronLeft, { color: colors.primary50, size: 22 }))))),
            React__default.createElement(MultiGrid$1, __assign({ height: height ? height : autoSizerParams.height, width: width ? width : autoSizerParams.width, classNameBottomRightGrid: clsx(styles.MultiGrid, classNameBottomRightGrid), classNameBottomLeftGrid: clsx(styles.MultiGrid, classNameBottomLeftGrid), classNameTopRightGrid: clsx(styles.MultiGrid, classNameTopRightGrid), classNameTopLeftGrid: clsx(styles.MultiGrid, classNameTopLeftGrid), rowHeight: safeRowHeight, cellRenderer: _this.renderCellContainer, scrollToColumn: _this.state.scrollPosition === 'left'
                    ? multiGridProps.fixedColumnCount
                    : multiGridProps.columnCount - 1 }, multiGridProps)))); }));
    };
    MultiGrid.displayName = 'MultiGrid';
    MultiGrid.propTypes = propTypes;
    MultiGrid.defaultProps = __assign({}, defaultProps);
    return MultiGrid;
}(React__default.Component));

export { MultiGrid as default };
